







































































import { Component, Mixins, Ref, Vue } from "vue-property-decorator";
import VModel from "@/components/VModal.vue";
import OperationProgress from "@/components/CatalogueSettings/OperationProgress.vue";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "../../store/types/RequestData";
import CatalogueSettingsMixin from "@/mixins/http/CatalogueSettingsMixin";

const UPLOAD_CATALOGUE_TAG = "upload_catalogue_tag";

@Component({ components: { VModel, OperationProgress } })
export default class Upload extends Mixins(CatalogueSettingsMixin) {
  @Ref("uploadCatalogue") readonly modalUpload!: VModel;
  @RegisterHttp(UPLOAD_CATALOGUE_TAG) readonly uploadRequestData!: RequestData;

  formData: FormData = null;
  pending = false;
  finished = false;
  outcome = null;
  errors = null;
  error = null;
  files = [];

  show() {
    this.modalUpload.show();
  }

  onFileChanged(e) {
    this.formData = new FormData();
    this.files = e.target.files || e.dataTransfer.files;

    Array.from(Array(this.files.length).keys()).map((x) => {
      this.formData.append("catalogue_file", this.files[x], this.files[x].name);
    });
  }

  get fileNames() {
    return Array.from(Array(this.files.length).keys())
      .map((x) => this.files[x].name)
      .join(",");
  }

  notifyData() {
    this.$emit("upload", this.formData);
  }

  onCompleted(payload) {
    this.onFinished();
    this.outcome = payload;
  }

  get positiveOutcomeText() {
    const productData = this.outcome.find((o) => o.sheet === "Products");
    return `${productData.imported} products were successfully imported!`;
  }

  onFailed(payload) {
    this.onFinished();
    if (Array.isArray(payload)) {
      this.errors = payload;
    } else {
      this.error = payload;
    }
  }

  hide() {
    this.modalUpload.hide();
    this.reset();
  }

  onFinished() {
    this.finished = true;
  }

  reset() {
    this.pending = false;
    this.finished = false;
    this.formData = null;
    this.errors = null;
    this.error = null;
    this.outcome = null;
    this.files = [];
  }

  async onConfirm() {
    if (this.finished) {
      this.hide();
    } else {
      await this.onUploadRequest();
    }
  }

  onCancel() {
    this.formData = null;
    this.reset();
    this.hide();
  }

  async onUploadRequest() {
    this.pending = true;
    const resp = await this.uploadCatalogue(
      this.formData,
      UPLOAD_CATALOGUE_TAG
    );
    const status = this.uploadRequestData;
  }
}
